import { Injectable, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators'
import { TCCPHttpService } from '../../shared/services/tccp-http.service';
import { TCCPConstantValues } from '../../shared/models/tccp-constants';
import { TCCPLoggerService } from '../../shared/services/tccp-logger.service';
import { environment } from '../../../environments/environment';
import { Banner } from '../../shared/models/Banner';

@Injectable({
  providedIn: 'root'
})
export class ManageBannerService {

  constructor(private logger: TCCPLoggerService, private httpService: TCCPHttpService) {

  }
  public appBase = TCCPConstantValues[environment.applicationName];
  public baseURL = this.appBase.Urls;
  public selectedBanner: string;
  public pageMode: string = null;

  /** For service call to get Banner
   * @class ManageBannerService
   * @method getBanners
   * @param status - status
   * @returns Observable
   */
  getBanner(division: string, status: string, bannerId?: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.BANNER_MODULE, this.appBase.methods.getBanner,
      'Started getting Banner', ''); /* banner / toyota / published */
    let url: string = null;
    if (bannerId) {
      url = this.baseURL.BANNER_CONTEXT + division + '/' + bannerId;
    } else {
      url = this.baseURL.BANNER_CONTEXT + 'banner/' + division + '/' + status;
    }
    /*  return this.httpService.get('../../../assets/data/admin/banners.json') */
    return this.httpService.get(url).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.BANNER_MODULE, this.appBase.methods.getBanner,
            'Getting Banner successful', JSON.stringify(data));
          return data;
        }),
      catchError((error: any) => {
          this.logger.logException(this.appBase.modules.BANNER_MODULE, this.appBase.methods.getBanner,
            'Getting Banner failed', '', error);
          return error;
        })
        );
      }

  /** For service call to update banner
    * @class ManageBannerService
    * @method updateBanner
    * @param Banner
    * @returns Observable
    */
  updateBanner(banner: Banner, bannerId: string, division: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.BANNER_MODULE, this.appBase.methods.saveBanner,
      'Started Updating Banner', '');
    const url = this.baseURL.BANNER_CONTEXT + division + '/' + bannerId;
    return this.httpService.post(url, banner).pipe(
    map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.BANNER_MODULE, this.appBase.methods.saveBanner,
            'Updating Banner successful', JSON.stringify(data));
          return data;
        }),
    catchError((error: any) => {
          this.logger.logException(this.appBase.modules.BANNER_MODULE, this.appBase.methods.saveBanner,
            'Updating Banner failed', '', error);
          return error;
        })
        );
  }

  /** For service call to insert banner
  * @class ManageBannerService
  * @method insertBanner
  * @param Banner 
  * @returns Observable
  */
  insertBanner(banner: Banner, division: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.BANNER_MODULE, this.appBase.methods.saveBanner,
      'Started Updating Banner', '');
    const url = this.baseURL.BANNER_CONTEXT + division;
    return this.httpService.post(url, banner).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.BANNER_MODULE, this.appBase.methods.saveBanner,
            'Updating Banner successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.BANNER_MODULE, this.appBase.methods.saveBanner,
            'Updating Banner failed', '', error);
          return error;
        })
    );
  }

  /** For service call to delete Banner
  * @class ManageBannerService
  * @method deleteBanner 
  * @returns Observable
  */
  deleteBanner(bannerId: string, division: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.BANNER_MODULE, this.appBase.methods.saveBanner,
      'Started Deleting Banner', '');
    const url = this.baseURL.BANNER_CONTEXT + division + '/' + bannerId;
    return this.httpService.delete(url).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.BANNER_MODULE, this.appBase.methods.saveBanner,
            'Deleting Banner successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.BANNER_MODULE, this.appBase.methods.saveBanner,
            'Deleting Banner failed', '', error);
          return error;
        })
    );
  }

  /** For service call to update status
  * @class ManageBannerService
  * @method updateStatus
  * @param Banner
  * @returns Observable
  */
  updateStatus(requestParameter, division: string, status: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.BANNER_MODULE, this.appBase.methods.saveBanner,
      'Started Updating Banner', '');
    const url = this.baseURL.BANNER_CONTEXT + division + '?status=' + status;
    return this.httpService.put(url, requestParameter).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.BANNER_MODULE, this.appBase.methods.saveBanner,
            'Updating Banner successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.BANNER_MODULE, this.appBase.methods.saveBanner,
            'Updating Banner failed', '', error);
          return error;
        })
    );
  }
}


